const ColorSwatch = ({ hex }) => (
  <div
    className="velorbis-customizer-color-swatch"
    style={{ backgroundColor: hex }}
  />
)
export default ColorSwatch
